import { html, rune, View } from 'rune-ts';
import klass from './ExhibitionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { ExhibitionCard } from './ExhibitionCard';
import { concat, map, pipe, range, slice, toArray } from '@fxts/core';
import { getResizedUrl } from '../../../../../shared/util/image';

export class ExhibitionSection extends View {
  topRowImageUrls = this._createImageUrls(8, 'top');
  bottomRowImageUrls = this._createImageUrls(8, 'bottom');

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      exhibition_title: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}exhibition_title`),
      ),
      exhibition_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}exhibition_description`),
      ),
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.exhibition_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_regular', mo: '14_regular' })}">
            ${texts.exhibition_description}
          </div>
        </div>

        <div class="${klass.content}">
          ${is_mobile
            ? html`
                <div class="${klass['marquee-wrapper']} ${klass.top}">
                  <div class="${klass['marquee-background']}">${this._renderMobileExhibition(10, 15)}</div>
                  <div class="${klass['marquee-background']}" aria-hidden="true">
                    ${this._renderMobileExhibition(10, 15)}
                  </div>
                </div>
                <div class="${klass['marquee-wrapper']} ${klass.middle}">
                  <div class="${klass['marquee-background']}">${this._renderMobileExhibition(1, 7)}</div>
                  <div class="${klass['marquee-background']}" aria-hidden="true">
                    ${this._renderMobileExhibition(1, 7)}
                  </div>
                </div>
                <div class="${klass['marquee-wrapper']} ${klass.bottom}">
                  <div class="${klass['marquee-background']}">${this._renderMobileExhibition(10, 15)}</div>
                  <div class="${klass['marquee-background']}" aria-hidden="true">
                    ${this._renderMobileExhibition(10, 15)}
                  </div>
                </div>
              `
            : html`
                <div class="${klass['marquee-wrapper']} ${klass.top}">
                  <div class="${klass['marquee-background']}">
                    ${this.topRowImageUrls.map((imageUrl) => new ExhibitionCard({ imageUrl }))}
                  </div>
                  <div class="${klass['marquee-background']}" aria-hidden="true">
                    ${this.topRowImageUrls.map((imageUrl) => new ExhibitionCard({ imageUrl }))}
                  </div>
                </div>

                <div class="${klass['marquee-wrapper']} ${klass.bottom}">
                  <div class="${klass['marquee-background']}">
                    ${this.bottomRowImageUrls.map((imageUrl) => new ExhibitionCard({ imageUrl }))}
                  </div>
                  <div class="${klass['marquee-background']}" aria-hidden="true">
                    ${this.bottomRowImageUrls.map((imageUrl) => new ExhibitionCard({ imageUrl }))}
                  </div>
                </div>
              `}
        </div>
      </section>
    `;
  }

  private _createImageUrls(length: number, row: 'bottom' | 'top') {
    return pipe(
      range(1, length + 1),
      map(
        (number) =>
          `//s3.marpple.co/files/u_14345/2024/6/original/plus/section5/exhibition-${row}-${number}.png`,
      ),
      map((imageUrl) =>
        getResizedUrl({
          url: imageUrl,
          width: 400,
          format: 'webp',
          quality: 85,
        }),
      ),
      toArray,
    );
  }

  private _renderMobileExhibition(from: number, to: number) {
    return pipe(
      this.topRowImageUrls,
      concat(this.bottomRowImageUrls),
      map((imageUrl) => new ExhibitionCard({ imageUrl })),
      slice(from, to),
      toArray,
    );
  }
}
